'use client';

import { memo } from 'react';

import { Spinner } from '@air/primitive-spinner';

export const LoadingState = memo(() => (
  <main className="flex h-screen items-center justify-center bg-white dark:bg-gray-1">
    <div className="flex flex-col items-center gap-3">
      <Spinner className="size-8 text-altitude-9" />
      <p className="text-14 text-gray-10">Loading your workspace...</p>
    </div>
  </main>
));

LoadingState.displayName = 'LoadingState';
